import { AppBar, Typography, Toolbar, Button, ButtonGroup } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

function NavBar (props) {
  const { setViewPage } = props

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='static' style={{ backgroundColor: '#223843' }}>
        <Toolbar>
          <Typography
            variant='h7'
            component='div'
            style={{
              fontSize: 'xx-large',
              textAlign: 'start',
              fontFamily: 'sans-serif',
              width: '100%',
              color: '#c0725d'
            }}
          >
            <strong>
              {'Assessing Algal Growth in Water Eutrophication (A. G. W. E.)'}
            </strong>
          </Typography>
        </Toolbar>
      </AppBar>
      <AppBar position='static' style={{ backgroundColor: '#223843' }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }} />
          <Typography>
            <Box>
              <ButtonGroup aria-label='outlined primary button group'>
                <Button
                  style={{ color: '#c0725d' }}
                  onClick={_ => setViewPage('AgwePage')}
                >
                  Home
                </Button>
                <Button
                  onClick={_ => setViewPage('AboutUsPage')}
                  style={{ color: '#c0725d' }}
                >
                  About Us
                </Button>
                {/* <Button
                  onClick={_ => setViewPage('AnalysisPage')}
                  style={{ color: '#c0725d' }}
                >
                  Analysis
                </Button> */}
                {/* <Button
                  onClick={_ => setViewPage('ResourcesPage')}
                  style={{ color: '#c0725d' }}
                >
                  MAP
                </Button> */}
                <Button
                  style={{ backgroundColor: '#c0725d' }}
                  variant='contained'
                  onClick={_ => setViewPage('ContactUsPage')}
                >
                  CONTACT
                </Button>
              </ButtonGroup>
            </Box>
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default NavBar
